import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsIntegration4V4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 34V64H31" stroke="#FFDD00" strokeWidth="2" />
      <path d="M65 30H35V0" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
